import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Microservices } from '@microservices';
import { Subscription } from 'rxjs';
import { DxcDialogService } from 'src/modules/primitives/dxc';
import { RoutesApp } from './constants/Routes.constants';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  private listeners: Subscription[] = [];

  constructor(
    private micro: Microservices,
    private router: Router,
    private dialog: DxcDialogService,
  ) {}

  setupListeners () {

  }

  removeListeners () {

  }

  displayCarrierDocumentUploadRequest () {
    return this.dialog.info({
      title: 'Faltan documentos de tu empresa',
      description: 'Para completar la negociación del embarque necesitas cargar tu Seguro de Unidades y/o tu Seguro de Responsabilidad Civil, la Constancia de Situación Fiscal y el permiso de la SCT para operar como SPF. Puedes subirlos uno por uno o como paquete.',
      closeLabel: 'Entendido',
    });
  }



  async displayCarrierDriverSetupRequest () {
    // El botón que navegaba vivía dentro del `html:` del modal, enganchado con
    // `addEventListener` en `willOpen`. Ahora es el botón del propio diálogo:
    // si el usuario lo cierra por Esc o por el velo, no se le lleva a ningún
    // sitio, que es lo que hacía antes.
    const ir = await this.dialog.info({
      title: 'Agrega un operador',
      description: 'Todavía no tienes ningún operador registrado. Necesitas al menos uno para poder mover un flete.',
      closeLabel: 'Agregar operador',
    });

    if (ir) this.router.navigate([RoutesApp.Assets.Driver]);
  }
}
